<ng-container *ngIf="control">
  @if (inputData?.type === 'password') {
    <mat-form-field class="mat-password" appearance="outline">
      <mat-label>{{ inputData?.label }}</mat-label>
      <input
        matInput
        [type]="hide ? 'password' : 'text'"
        [formControl]="control"
        autocomplete="cc-name" />
      <mat-icon
        *ngIf="inputData?.key !== 'confirm_password'"
        matSuffix
        (click)="generatePassword()">
        refresh
      </mat-icon>
      <span
        class="me-2"
        mat-icon-button
        matSuffix
        (click)="hide = !hide"
        [attr.aria-label]="'Hide password'"
        [attr.aria-pressed]="hide"
        [attr.aria-hidden]="true">
        <mat-icon>
          {{ hide ? 'visibility_off' : 'visibility' }}
        </mat-icon>
      </span>
    </mat-form-field>
  } @else if (inputData?.type === 'number') {
    <mat-form-field appearance="outline">
      <mat-label>{{ inputData?.label }}</mat-label>
      <input
        matInput
        (input)="onInput($event)"
        type="number"
        [placeholder]="inputData?.placeholder ?? ''"
        [formControl]="control"
        autocomplete="cc-name" />
    </mat-form-field>
  } @else {
    <mat-form-field appearance="outline">
      <mat-label>{{ inputData?.label }}</mat-label>
      <input
        matInput
        (input)="onInput($event)"
        [type]="inputData?.type ?? ''"
        [placeholder]="inputData?.placeholder ?? ''"
        [formControl]="control"
        autocomplete="cc-name" />
    </mat-form-field>
  }

  <!-- Validation Error -->
  <app-validation-error
    [control]="control"
    [inputData]="inputData"></app-validation-error>
</ng-container>
